import { Dispatch } from "@reduxjs/toolkit";
import {
  setLocalStorageData,
  updateOpeningSource,
  openLeadFormModal,
} from "../LeadFormModal/data/leadFormReducer";

class LeadFormDispatcher {
  private dispatch;

  constructor(dispatch: Dispatch) {
    this.dispatch = dispatch;
  }

  handleOnEnquireClick({ data, source, page }: { data: any; source: string; page?: number }) {
    this.dispatch(setLocalStorageData());
    this.dispatch(updateOpeningSource({ openingSource: source }));
    this.dispatch(
      openLeadFormModal({
        inventory: data,
        inModal: true,
        ...(page && { leadFormPage: page }),
      }),
    );
  }
}

export default LeadFormDispatcher;
